import { render, staticRenderFns } from "./user-options.vue?vue&type=template&id=09895624&scoped=true&"
import script from "./user-options.vue?vue&type=script&lang=js&"
export * from "./user-options.vue?vue&type=script&lang=js&"
import style0 from "./user-options.vue?vue&type=style&index=0&id=09895624&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09895624",
  null
  
)

export default component.exports